import { useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

const TIMEOUT_MS = 30 * 60 * 1000;
const WARNING_MS = 2 * 60 * 1000;
const EVENTS = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];

const useSessionTimeout = () => {
  const { logout, user } = useAuth();
  const timeoutRef = useRef<any>(null);
  const warningRef = useRef<any>(null);
  const warningShownRef = useRef(false);

  const clearTimers = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (warningRef.current) clearTimeout(warningRef.current);
  };

  const handleLogout = useCallback(() => {
    clearTimers();
    toast.error('Sesión cerrada por inactividad');
    setTimeout(() => { logout(); window.location.href = '/login'; }, 1500);
  }, [logout]);

  const resetTimer = useCallback(() => {
    clearTimers();
    warningShownRef.current = false;
    warningRef.current = setTimeout(() => {
      if (!warningShownRef.current) {
        warningShownRef.current = true;
        toast('Tu sesión cerrará en 2 minutos por inactividad', {
          icon: '⏱️', duration: 10000,
          style: { background: '#1e1b4b', color: 'white', border: '1px solid #6366f1' }
        });
      }
    }, TIMEOUT_MS - WARNING_MS);
    timeoutRef.current = setTimeout(handleLogout, TIMEOUT_MS);
  }, [handleLogout]);

  useEffect(() => {
    if (!user) return;
    resetTimer();
    EVENTS.forEach(e => window.addEventListener(e, resetTimer, { passive: true }));
    return () => {
      clearTimers();
      EVENTS.forEach(e => window.removeEventListener(e, resetTimer));
    };
  }, [user, resetTimer]);
};

export default useSessionTimeout;
